export default __webpack_public_path__ + "static/media/Boots of the Dragon King.941b597c.jpg";